/* Note:
 *
 * @types/react used in @dtpk-cc (v16.x.x) is incompatible with @types/react installed in this app (v.18.x.x).
 * In this specific case here, it's ReactFragment not exporting {} anymore.
 * To avoid running into an error, we use the @ts-ignore rule. But since all warnings are treated as errors, we need
 * to disable the eslint warning for this file.
 *
 * We can remove all this as soon as dtpk-cc relies on React v18
 *
 * */
/* eslint @typescript-eslint/ban-ts-comment: 0 */

import { Modal, ModalProps } from '@dtpk-cc/components';

type InfoModalProps = ModalProps & {
    headline: string;
};

export const InfoModal = ({ headline, children, ...modalProps }: InfoModalProps) => (
    // @ts-ignore
    // eslint-disable-next-line react/jsx-props-no-spreading
    <Modal {...modalProps}>
        <div data-test-section="modal-body">
            <Modal.Section>
                <Modal.Heading variant={Modal.Heading.Variant.hint}>{headline}</Modal.Heading>
                {children}
            </Modal.Section>
        </div>
    </Modal>
);
